import React from "react";
import PropTypes from "prop-types";
import CompletedSetIndicator from "./CompletedSetIndicator";
import InProgressSetIndicator from "./InProgressSetIndicator";

function ScoreIndicator({ completedSets, data = {}, status }) {
  console.log("ScoreIndicator", completedSets, data, status);
  return (
    <div className="ScoreIndicator">
      <CompletedSetIndicator data={completedSets} />
      <InProgressSetIndicator data={data} status={status} />
    </div>
  );
}

ScoreIndicator.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      games: PropTypes.number.isRequired,
      tieBreakPoint: PropTypes.number,
      winner: PropTypes.bool.isRequired,
      finalTieBreak: PropTypes.bool,
    }),
  ),
};

export default ScoreIndicator;
